import { createCardEvent } from '@lc/interface/card/event/factory';

export const EventMeta = [
	createCardEvent(
		144,
		0,
		`SPARE CALCULATOR BATTERIES`,
		`RECHARGE ONE (1) BATTERY FOR EVERY TWO (2) FACTORIES YOU OWN YOUR NEIGHBORS MAY GIVE YOU TWO (2) PR TO PREVENT THIS (THEY DECIDE HOW TO DIVIDE THE BURDEN)`,
		`“IF THOU GAZE LONG INTO A BATTERY, THE BATTERY WILL ALSO GAZE INTO THEE.”`
	),
	createCardEvent(
		145,
		0,
		`“HE DID IT”`,
		`IF YOU HAVE A HIGHER PR THAN ANOTHER PLAYER, YOU MAY PLACE ONE (1) CARBON FROM YOUR FOOTPRINT INTO THEIR FOOTPRINT`,
		`“YOUR MOM STILL DOESN’T BELIEVE YOU.”`,
		true
	),
	createCardEvent(
		// TODO SPECIAL EVENT
		146,
		0,
		`COMPARATIVE ADVERTISING`,
		`ALL PLAYERS THIS MONTH MAY DISCARD ONE (1) OF THEIR COLOR ENERGY TO PLACE TWO (2) ENERGY OF A NEIGHBOR’S COLOR INTO THEIR CUP.`,
		`“OURS IS BETTER BECAUSE THEIRS IS WORSE™”`
	),
	createCardEvent(
		// TODO SPECIAL EVENT
		147,
		0,
		`COMPARATIVE ADVERTISING`,
		`ALL PLAYERS THIS MONTH MAY DISCARD ONE (1) OF THEIR COLOR ENERGY TO PLACE TWO (2) ENERGY OF A NEIGHBOR’S COLOR INTO THEIR CUP.`,
		`“OURS IS BETTER BECAUSE THEIRS IS WORSE™”`
	),
	createCardEvent(
		148,
		0,
		`FORCED DONATION`,
		`TAKE UP TO TWO (2) ENERGY FROM A NEIGHBOR’S FACTORIES OR BATTERIES AND PUT IT IN THEIR CUP`,
		`“WE APPRECIATE YOUR SACRIFICE.”`,
		true
	),
	createCardEvent(
		149,
		0,
		`CONTRIBUTION MATCHING`,
		`YOU AND A NEIGHBOR EACH CHARGE A BATTERY, BUT WITH EACH OTHER’S ENERGY`,
		`“NO, YOU CONTRIBUTE FIRST ;)”`,
		true
	),
	createCardEvent(
		150,
		2,
		`TWO WRONGS MAKE A RIGHT`,
		`STEAL A CONTRACT FROM ANOTHER PLAYER’S COMPLETED CONTRACT PILE AND GAIN THE FUNDING IMMEDIATELY, PUT THE CONTRACT IN YOUR FAILED PILE *YOU DO NOT RECEIVE THE PENALTY*`,
		`“THIRD TIME’S THE CHARM.”`,
		true
	),
	createCardEvent(
		151,
		2,
		`TWO WRONGS MAKE A RIGHT`,
		`STEAL A CONTRACT FROM ANOTHER PLAYER’S COMPLETED CONTRACT PILE AND GAIN THE FUNDING IMMEDIATELY, PUT THE CONTRACT IN YOUR FAILED PILE *YOU DO NOT RECEIVE THE PENALTY*`,
		`“THIRD TIME’S THE CHARM.”`,
		true
	),
	createCardEvent(
		152,
		1,
		`HACKTIVIST GROUP RELEASES TAX RETURNS`,
		`TAKE ALL THE PR FROM A PLAYER’S MAT THAT IS NOT THEIR COLOR AND ADD IT TO YOUR OWN PR`,
		`“GRADUATED INCOME TAX. AS IN, I HAVE GRADUATED FROM PAYING THE INCOME TAX.”`,
		true
	),
	createCardEvent(
		153,
		0,
		`KARMA`,
		`PICK A PLAYER WITH A HIGHER CARBON FOOTPRINT THAN YOU STEAL AN EQUIPMENT FROM THAT PLAYER. IF THEY HAVE NO EQUIPMENT STEAL A BATTERY. IF THEY HAVE NEITHER, STEAL A FACTORY`,
		`“RELEASE ALL OF THEIR MATERIAL ATTACHMENTS”`,
		true
	),
	createCardEvent(
		154,
		0,
		`OVERCHARGE`,
		`RECHARGE UP TO TWO (2) OF YOUR BATTERIES EACH OF YOUR NEIGHBORS RECHARGE ONE (1) BATTERY WITH AN ENERGY OF YOUR COLOR`,
		`“WHY DOES IT HERTZ SO GOOD?”`
	),
	createCardEvent(
		155,
		0,
		`OVERCHARGE`,
		`RECHARGE UP TO TWO (2) OF YOUR BATTERIES EACH OF YOUR NEIGHBORS RECHARGE ONE (1) BATTERY WITH AN ENERGY OF YOUR COLOR`,
		`“WHY DOES IT HERTZ SO GOOD?”`
	),
	createCardEvent(
		156,
		0,
		`OVERCHARGE`,
		`RECHARGE UP TO TWO (2) OF YOUR BATTERIES EACH OF YOUR NEIGHBORS RECHARGE ONE (1) BATTERY WITH AN ENERGY OF YOUR COLOR`,
		`“WHY DOES IT HERTZ SO GOOD?”`
	),
	createCardEvent(
		157,
		2,
		`INVESTIGATIVE JOURNALISM`,
		`IF A NEIGHBORING PLAYER HAS A HIGHER CARBON FOOTPRINT THAN YOU SWITCH PR WITH THEM`,
		`“HE DIDN’T MAKE IT IN, BUT HE GOT SOME REALLY FLATTERING PICTURES OF THE SECURITY GUARDS.”`,
		true
	),
	createCardEvent(
		158,
		1,
		`HACK A RIVAL COMPANY’S SOCIAL MEDIA PAGE`,
		`GAIN ONE (1) PR FROM EACH OF YOUR NEIGHBORS IN THEIR COLOR *THIS PR COMES FROM THEIR INACTIVE ENERGY*`,
		`“OUR RELATIONSHIP WITH THE ENVIRONMENT? IT’S COMPLICATED.”`
	),
	createCardEvent(
		159,
		0,
		`STUFF AN ELECTRIC EEL INTO A BATTERY`,
		`RECHARGE ONE (1) BATTERY`,
		`“ANIMAL CRUELTY? HE LIKES IT IN THERE!”`
	),
	createCardEvent(
		160,
		0,
		`DAM A LOG FLUME`,
		`RECHARGE ONE (1) BATTERY`,
		`“THE ONLY ANIMAL THAT APPROVED THIS ON SPLASH MOUNTAIN WAS THE BEAVER.”`
	),
	createCardEvent(
		// SPECIAL EVENT, NEEDS TO ALLOW PLAYER DECISION
		161,
		0,
		`SURPRISE INSPECTION`,
		`LOWER ANOTHER PLAYER’S PR BY THEIR CARBON FOOTPRINT. THEY MAY GIVE YOU ONE (1) ENERGY TO PREVENT THIS`,
		`“AT LEAST THEY HAD BALLOONS AND A CAKE.”`,
		true
	),
	createCardEvent(
		// SPECIAL EVENT, NEEDS TO ALLOW PLAYER DECISION
		162,
		0,
		`SURPRISE INSPECTION`,
		`LOWER ANOTHER PLAYER’S PR BY THEIR CARBON FOOTPRINT. THEY MAY GIVE YOU ONE (1) ENERGY TO PREVENT THIS`,
		`“AT LEAST THEY HAD BALLOONS AND A CAKE.”`,
		true
	),
	createCardEvent(
		// SPECIAL EVENT, NEEDS DECISION
		163,
		0,
		`GARAGE SALE`,
		`YOU MAY DISCARD UP TO TWO (2) BATTERIES. PLACE ONE (1) ENERGY IN YOUR CUP FOR EACH DISCARDED BATTERY -OR- BUY A BATTERY FOR ONE (1) ENERGY`,
		`“THE PRICE ON THE TAG IS FINAL.”`,
		false,
		false,
		true
	),
	createCardEvent(
		164,
		0,
		`GARAGE SALE`,
		`YOU MAY DISCARD UP TO TWO (2) BATTERIES. PLACE ONE (1) ENERGY IN YOUR CUP FOR EACH DISCARDED BATTERY -OR- BUY A BATTERY FOR ONE (1) ENERGY`,
		`“THE PRICE ON THE TAG IS FINAL.”`,
		false,
		false,
		true
	),
	createCardEvent(
		165,
		1,
		`MISINFORMATION`,
		`PLAY IN FRONT OF A PLAYER WITH A LOWER PR THAN YOU NEXT MONTH THEIR ENERGY OUTPUT IS REDUCED BY TWO (2)`,
		`“THE PROBLEM WITH QUOTES ON THE INTERNET IS IT’S HARD TO VERIFY THEIR AUTHENTICITY” - ABRAHAM LINCOLN`,
		true
	),
	createCardEvent(
		166,
		0,
		`CIVIL FORFEITURE`,
		`STEAL AN ENERGY FROM ANOTHER PLAYER, IN RETURN THAT PLAYER CAN DRAW A CARD AT RANDOM FROM YOUR HAND *YOU MUST HAVE AT LEAST ONE (1) CARD OTHER THAN THIS ONE IN YOUR HAND TO PLAY THIS CARD.*`,
		`“THE PEOPLE VS. THAT RATHER NICE WATCH.”`,
		true
	),
	createCardEvent(
		167,
		0,
		`DEVELOP CO 2 ABSORBING ICE CREAM`,
		`TAKE TWO (2) CARBON FROM ANOTHER PLAYER’S CARBON FOOTPRINT AND PLACE IT INTO YOUR CARBON RESERVE`,
		`“IT’S FIZZY AND IT MAKES YOU DIZZY.”`,
		true
	),
	createCardEvent(
		168,
		1,
		`MAKE A BOARD GAME ABOUT RENEWABLE ENERGY`,
		`DRAW THREE (3) CARDS`,
		`“WE’RE DISRUPTING THE MARKET.”`
	),
	createCardEvent(
		169,
		1,
		`RELEASE AN INFOMERCIAL ON RENEWABLE ENERGY`,
		`DRAW THREE (3) CARDS`,
		`“CALL IN THE NEXT 30 SECONDS AND WE’LL DOUBLE THE LIFESPAN OF THIS PLANET!”`
	),
];
